// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"e773ac6a","204":"d2545dde","234":"b078477b","613":"246cfacb","653":"3e2478d1","844":"bcc60ea1","848":"7539992a"}[chunkId] + ".chunk.js";
};